import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import PaginationTest from "Common/Components/Paginationtest";

const Index = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataListProvince, setDataListProvince] = useState<any>([]);
  const [dataListCity, setdataListCity] = useState<any>([]);
  const [dataListProvinceValue, setDataListProvinceValue] = useState<any>(null);
  const [dataListCityVAlue, setdataListCityVAlue] = useState<any>(null);
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/city/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListCity(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/province/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDataListProvince(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;

    // اطمینان از اینکه alldata مقدار عددی معتبر دارد
    const totalItems = alldata ? Number(alldata) : 0;

    // بررسی اینکه صفحه فعلی با تعداد داده‌ها و سایز جدید هماهنگ باشد
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize)); // تنظیم صفحه به آخرین صفحه موجود
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(newPage, newSize);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue ? searchValue : null]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const fetchData = async (page: number, size: number) => {
    try {
      const params: any = {
        sort_by: "updated_at",
        sort_order: "desc",
        page,
        size,
        search: searchValue,
      };
      setData([]);
      // فقط اگر مقدار معتبر داشت city_id اضافه کن
      if (dataListCityVAlue && dataListCityVAlue !== "null") {
        params.city_id = dataListCityVAlue;
      }
      const res = await axios.get("https://api.havirkesht.ir/village/", {
        params,
      });
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      const items = res?.data?.items || [];
      setData(items);
      setload(items.length === 0);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response) {
        setErrorMessage("خطا در دریافت داده‌ها از سرور");
      } else if (error.request) {
        setErrorMessage(
          "ارتباط با سرور برقرار نشد. اینترنت یا فیلترشکن را بررسی کنید."
        );
      } else {
        // setErrorMessage("خطای غیرمنتظره! لطفاً بعداً تلاش کنید.");
      }
      setload(true);
    }
  };

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.village) {
      setEventData(cell.village);
    }
  };
  const handleCreateVillage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const isProvinceSelected =
      dataListProvinceValue != null && dataListProvinceValue != "null";
    const isCitySelected =
      dataListCityVAlue != null && dataListCityVAlue != "null";
    if (!isProvinceSelected || !isCitySelected) {
      toast.error("لطفاً ابتدا استان و شهرستان را انتخاب کنید");
      return;
    }
    setShow(true);
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/village/${eventData}`
      );
      if (res.status === 200) {
        toast.success("عملیات حذف با موفقیت انجام شد");
        setreload(!reload);
      } else {
        toast.error("مشکل در حذف داده");
      }
      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      village: "",
    },
    validationSchema: Yup.object({
      village: Yup.string().required("لطفاً نام روستا را وارد کنید"),
    }),
    onSubmit: async (values) => {
      const newData = {
        village: values.village,
        city_id: Number(dataListCityVAlue),
      };
      const res = await axios.post(
        "https://api.havirkesht.ir/village/",
        newData
      );
      console.log(res);

      if (res.status === 201) {
        toast.success(`روستا جدید ثبت شد`);
        setreload(!reload);
        setShow(false);
      } else {
        toast.error(`خطا در ثبت`);
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = useMemo(
    () => [
      {
        header: "روستا",
        accessorKey: "village",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت روستا" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}

      <div className="flex flex-col sm:flex-row w-full max-w-xs sm:max-w-md lg:w-[40rem] mb-3 items-start sm:items-center gap-2 sm:gap-1 lg:gap-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center w-full sm:flex-1 gap-2 sm:gap-1 lg:gap-2">
          <label
            htmlFor="province"
            className="text-base font-medium sm:w-16 lg:w-20 flex-shrink-0"
          >
            استان:
          </label>
          <select
            id="province"
            className="w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:border-gray-200"
            onChange={(e) => setDataListProvinceValue(e.target.value)}
          >
            <option value="null">انتخاب استان</option>
            {dataListProvince?.map((data: any) => (
              <option key={data.id} value={data.id}>
                {data?.province}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center w-full sm:flex-1 gap-2 sm:gap-1 lg:gap-2">
          <label
            htmlFor="City"
            className="text-base font-medium sm:w-16 lg:w-20 flex-shrink-0"
          >
            شهرستان:
          </label>
          <select
            id="City"
            className="w-full px-1 py-2 border border-gray-200 rounded bg-white text-gray-900 dark:border-gray-200"
            onChange={(e) => setdataListCityVAlue(e.target.value)}
          >
            <option value="null">انتخاب شهرستان</option>
            {dataListCity?.map((data: any) => (
              <option key={data.id} value={data.id}>
                {data?.city}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
            <div className="w-full md:w-auto">
              <h6 className="text-15 mb-2">
                مجموع روستا (
                <b className="total-Employs">{alldata?.toString()}</b>)
              </h6>

              <label className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border border-gray-500 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute inset-y-0 left-2 flex items-center text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11 17a6 6 0 100-12 6 6 0 000 12zm10 4l-4.35-4.35"
                      />
                    </svg>
                  </span>
                </div>
              </label>
            </div>

            {/* بخش سمت راست - دکمه‌ها */}
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
              <div className="w-full sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>
              <div className="w-full sm:w-auto shrink-0">
                <button
                  onClick={handleCreateVillage}
                  type="button"
                  className="block text-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
                >
                  <span className="align-middle rtl">ایجاد روستا جدید</span>{" "}
                  <Plus className="inline-block size-4 rtl" />
                </button>
              </div>
            </div>
          </div>

          {/* بخش جدول */}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}

          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16"> ایجاد روستا جدید </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800">
                <div className="flex items-center">
                  <label
                    htmlFor="village"
                    className="text-base font-medium mr-2 w-1/4"
                  >
                    روستا :
                  </label>
                  <input
                    type="text"
                    id="village"
                    className="form-input text-black font-[12px] "
                    placeholder="نام روستا را وارد کنید:"
                    name="village"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.village}
                  />
                </div>
                {validation.touched.village && validation.errors.village && (
                  <p className="text-red-400 mr-24 mt-2">
                    {validation.errors.village}
                  </p>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Index;
